import { render, staticRenderFns } from "./AppointmentLogin.vue?vue&type=template&id=24330aa5&scoped=true&"
import script from "./AppointmentLogin.vue?vue&type=script&lang=js&"
export * from "./AppointmentLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentLogin.vue?vue&type=style&index=0&id=24330aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24330aa5",
  null
  
)

export default component.exports